<template>
  <div class="box-body">
    <!-- <label class="label">
      <input class="label__checkbox" type="checkbox" />
      <span class="label__text">
        <span class="label__check"> <i class="fa fa-check icon"></i> </span>
      </span>
    </label> -->
    <table class="responsive-table-input-matrix">
      <thead>
        <tr>
          <th>{{ $t("sidebar.decentralizationManagement.function") }}</th>
          <th>
            <i class="fa fa-eye"></i>
            {{ $t("sidebar.decentralizationManagement.watch") }}
          </th>
          <th>
            <i class="fa fa-plus"></i>
            {{ $t("sidebar.decentralizationManagement.create") }}
          </th>
          <th>
            <i class="fa fa-edit"></i>
            {{ $t("sidebar.decentralizationManagement.edit") }}
          </th>
          <th>
            <i class="fa fa-trash"></i>
            {{ $t("sidebar.decentralizationManagement.delete") }}
          </th>
          <th>
            <i class="fa fa-print"></i>
            {{ $t("sidebar.decentralizationManagement.print") }}
          </th>
          <th>
            <i class="fa fa-download"></i>
            {{ $t("sidebar.decentralizationManagement.export") }}
          </th>
          <th>
            <i class="fa fa-upload"></i>
            {{ $t("sidebar.decentralizationManagement.import") }}
          </th>
          <th>
            <i class="fa fa-check-square"></i>
            {{ $t("sidebar.decentralizationManagement.approve") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="f in permission_data.functions" :key="f.id">
          <td>{{ $t(`sidebar.decentralizationManagement.functions.${f.function_name}`) }}</td>
          <td v-for="p in f.permissions" :key="p.id">
            <input
              type="checkbox"
              :name="p.permission_code"
              @change="onChange(p)"
              v-model="p.enabled"
              :disabled="p.disable_action"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
// import LTETable from "@/components/LTETable.vue";

export default {
  name: "GroupPermissionsList",
  props: ["data"],
  data() {
    return {
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      boxStyle: false,
      permission_actions: [
        "view",
        "create",
        "update",
        "delete",
        "print",
        "export",
        "import",
        "approve"
      ],
      permission_prefix_dict: {
        view: 1,
        create: 2,
        update: 3,
        delete: 4,
        print: 5,
        export: 6,
        import: 7,
        approve: 8
      }
    };
  },
  computed: {
    permission_data: {
      get: function() {
        return this.data;
      }
    }
  },
  watch: {
    permission_data: function() {
      let f_permissions_data = this.permission_data.functions;
      f_permissions_data.forEach(
        function(f) {
          let permissions = f.permissions;
          let available_perm = [];
          permissions.forEach(perm => {
            let perm_prefix = perm.permission_code.split("_")[0];
            if (this.permission_actions.indexOf(perm_prefix) > -1) {
              perm.disable_action = false
              available_perm.push(perm_prefix);
            }
          });
          let unavail_perm = this.permission_actions.filter(
            x => available_perm.indexOf(x) < 0
          );
          unavail_perm.forEach(perm => {
            let item = {
              enabled: false,
              permission_code: `${perm}_${f.function_name}`,
              permission_name: `can ${perm} ${f.function_name}`,
              func_id: f.id,
              disable_action: true
            };
            permissions.push(item);
          });
          permissions.sort(this.compare_permission_prefix);
        }.bind(this)
      );
    }
  },
  mounted() {},
  created() {},
  methods: {
    onChange: function(data) {
      this.$emit("permissionChange", data);
    },
    compare_permission_prefix: function(a, b) {
      let a_prefix = a.permission_code.split("_")[0];
      let b_prefix = b.permission_code.split("_")[0];
      if (
        this.permission_prefix_dict[a_prefix] >
        this.permission_prefix_dict[b_prefix]
      ) {
        return 1;
      }
      if (
        this.permission_prefix_dict[a_prefix] <
        this.permission_prefix_dict[b_prefix]
      ) {
        return -1;
      }
      return 0;
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.row_mouse_pointer {
  cursor: pointer;
}

.isVisibility {
  display: none;
}
table > th {
  cursor: pointer;
}
div .right-search {
  width: 300px;
  margin-bottom: 5px;
  float: right;
}

div .left-search {
  width: 300px;
  margin-bottom: 5px;
  float: left;
}

th,
td {
  min-width: 50px;
  padding: 5px 7px;
  // padding: 10px 20px;
}

th.active {
  color: aquamarine;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fae042;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fae042;
}

th.active .other_color_arrow {
  opacity: 1;
}

.other_color_arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.other_color_arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid black;
}

.other_color_arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid black;
}

#grid-template {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  width: 600px;
}
.custom-box {
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #e6e9ed;
  border-bottom: 0px;
  margin-bottom: 2px;
  width: 100%;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.1);
}
.active_line {
  // wheat
  background-color: lightblue;
}
.more-btn,
.more-menu-btn {
  border-radius: 5px;
  background-color: #c9302c;
  border: 0 none;
  // border-color: #ac2925;
  line-height: normal;
  overflow: visible;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  width: 100%;
  text-align: left;
  margin-bottom: 0px;
  outline: none;
  cursor: pointer;
}

.more-dot {
  background-color: white;
  margin: 0 auto;
  display: inline-block;
  width: 5px;
  height: 5px;
  margin-right: 1px;
  margin-bottom: 2px;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.label-darkcyan {
  background-color: darkcyan !important;
}
.label-crimson {
  background-color: crimson !important;
}
.label-darkblue {
  background-color: darkblue !important;
}
.headerbackground {
  background-color: #4b646f;
  color: white;
  border: 1px solid white;
}
table {
  width: 100%;
  border-collapse: collapse;
}
/* Zebra striping */
tr:nth-of-type(odd) {
  background: #eee;
}
th {
  background: #4b646f;
  color: white;
  font-weight: bold;
}
td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: center;
}
tr {
  border-bottom: 1px solid gray;
}
.custom_checkbox {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupPermissionsList.vue